import Axios from "../../../../../api/axios/Axios";

const requireGroupTag = (value) => {
  const groupTag = String(value ?? "").trim();

  if (!groupTag) {
    throw new Error("A valid group tag is required.");
  }

  return encodeURIComponent(groupTag);
};

const requireStreamId = (value) => {
  const streamId = Number(value);

  if (!Number.isSafeInteger(streamId) || streamId <= 0) {
    throw new Error("A valid stream session ID is required.");
  }

  return streamId;
};

export const getGroupMemberStreams = (
  groupTag,
  { limit = 12, offset = 0, signal } = {},
) =>
  Axios.get(`/api/streams/groups/${requireGroupTag(groupTag)}`, {
    params: { limit, offset },
    signal,
  });

export const getGroupMemberStreamWatch = (streamSessionId, { signal } = {}) =>
  Axios.get(`/api/streams/${requireStreamId(streamSessionId)}/watch`, {
    signal,
  });
